import { ComboboxItem, Select, Text, TextInput, Tooltip } from "@mantine/core";
import React, { useEffect } from "react";
import classesButton from "../../../../../src/Styles/StyleButton.module.css";
import { repositoryMdm } from "../../../../_base/_const/_constVar";
import { formatDateTransfer } from "../../../../common/FormatDate/FormatDate";
import { MessageResponse } from "../../../../model/MessageResponse";
import { SelectListItem } from "../../../../model/SelectListItem";
import { tblInventoryTransaction } from "../../../../model/TblOutWard";
import RenderTable from "./RenderTable";

interface OrderDetail {
  cod: number;
  shippingVendor: string;
  customerId: number;
  customerName: string;
  telephoneNumber: string;
  customerAddress: string;
  customerProvinceId: string;
  customerDistrictId: string;
  customerCommuneId: string;
  deliveryAppointmentTime: string; // ISO 8601 format
  typeShip: string;
  timeDelivery: string;
  timeDeliveryTime: number;
  sourceType: number;
  status: boolean;
  width: number;
  length: number;
  height: number;
  branchId: number;
}
//Interface gọi tỉnh thành phố
export interface Province {
  id: number;
  nameprovince: string;
  note: string | null;
  codeprovince: string;
  active: boolean;
  codeprovinceweb: string;
  createdate: string | null;
  lastupdatedate: string | null;
  createby: string | null;
  lastupdateby: string | null;
}

// Interface cho Xã Phường mới
export interface CommuneMoi {
  id: number;
  code: string;
  name: string;
  note: string | null;
  active: boolean;
  provinceId: number;
  codeCommuneWeb: string | null;
  createdBy: string | null;
  createdAt: string | null;
  lastUpdatedBy: string | null;
  lastUpdatedAt: string | null;
  provinceName: string;
}

const SaleOrderOutward = ({
  dataSearchSourceCodeOption,
  dataOutWard,
  sourceCode,
  setSourceCode,
  handleKeyDownSourceCode,
  dataOrderDetail,
  handleChangeValueInput,
  isSave,
  setSearchSourceCode,
  isEdit,
  isLocked,
  haveSourceCode,
  action,
  dataBranch,
  updatedDataInventoryTransactionType,
}: SaleOrderOutwardProps) => {
  // Đây là state lưu địa chỉ Xã phường mới
  const [dataCommuneMoi, setDataCommuneMoi] = React.useState<SelectListItem[]>(
    [],
  );

  const parseAttribute5 = (attribute5: string) => {
    if (!attribute5) return { name: null, phone: null };
    const parts = attribute5.split(" - ");
    return {
      name: parts[0]?.trim() || null,
      phone: parts[1]?.trim() || null,
    };
  };

  const attribute5Data = parseAttribute5(dataOrderDetail?.attribute5);

  const isDisabled =
    dataOutWard.status === "LOCK" ||
    sourceCode ||
    isSave ||
    ["DETAIL", "EDIT"].includes(action);
  const headers = [
    { label: "", style: { width: "25%" } },
    { label: "Bên xuất", style: { width: "25%" } },
    { label: "", style: { width: "25%" } },
    { label: "Bên nhận", style: { width: "25%" } },
  ];

  const getDeliveryText = (delivery: string) => {
    switch (delivery) {
      case "KHONG":
        return "Nhận tại cửa hàng";
      case "NOI_BO":
      case "HA_COM":
        return "Nội bộ";
      default:
        return delivery;
    }
  };

  const attribute3 = dataOrderDetail?.attribute3;
  const checkDvtn = dataOrderDetail?.dvtn;
  let parsedData: OrderDetail | null = null;

  try {
    parsedData = attribute3 ? JSON.parse(attribute3) : null;
  } catch (error) {
    console.error("Error parsing JSON:", error);
  }

  useEffect(() => {
    if (dataOrderDetail) {
      // Xác định idCheck và paramType ở ngoài useEffect
      let idCheck: string | undefined = undefined;
      let paramType: "Ids" | "OldCommuneId" | undefined = undefined;
      // NOTE:CHUYỂN ĐỔI LOGIC LẤY HẾT ĐỊA CHỈ MỚI LÊN CHỈ DÙNG TYPE LÀ IDS THÔI
      if (dataOrderDetail?.dvtn) {
        // nếu là đơn vị tiếp nhận thì mặc định truyền vào OldCommuneId
        idCheck = parsedData?.customerCommuneId;
        paramType = "Ids";
      } else if (dataOrderDetail?.newCommuneId && !dataOrderDetail?.dvtn) {
        //nếu là địa chỉ mới thì truyền vào Ids
        idCheck = dataOrderDetail.newCommuneId;
        paramType = "Ids";
      } else if (dataOrderDetail?.cusCommuneId && !dataOrderDetail?.dvtn) {
        //nếu là địa chỉ cũ thì truyền vào OldCommuneId
        idCheck = dataOrderDetail.cusCommuneId;
        paramType = "Ids";
      }
      //  else if (checkDvtn && dataOrderDetail?.newCommuneId) {
      //   // nếu là đơn vị tiếp nhận
      //   idCheck = parsedData?.customerCommuneId;
      //   paramType = "Ids";
      // }
      const fetchDataReceiptCommuneMoi = async () => {
        if (!idCheck || !paramType) return;
        const url = `/api/v1/TblDmCommuneMoi/get-select?${paramType}=${idCheck}`;
        const response =
          await repositoryMdm.get<MessageResponse<SelectListItem[]>>(url);

        if (response && response.success) {
          let result = response.data;
          setDataCommuneMoi(result);
        }
      };

      fetchDataReceiptCommuneMoi();
    }
  }, [dataOrderDetail]);

  const rows = [
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Thời gian tạo
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {formatDateTransfer(dataOrderDetail?.createDate ?? "")}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Mã số khách hàng
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {checkDvtn ? parsedData?.customerId : dataOrderDetail?.cusCode}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Thời gian hoàn thành
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {formatDateTransfer(dataOutWard?.finishDate)}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Họ & Tên
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {/* {dataOrderDetail?.attribute5 === null
              ? checkDvtn
                ? parsedData?.customerName
                : dataOrderDetail?.cusName
              : attribute5Data.name} */}
            {checkDvtn
              ? parsedData?.customerName
              : attribute5Data?.name || dataOrderDetail?.cusName}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Mã phiếu xuất kho
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOutWard?.transactionCode}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Số điện thoại
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {/* {dataOrderDetail?.attribute5 === null
              ? checkDvtn
                ? parsedData?.telephoneNumber
                : dataOrderDetail?.cusTelephone
              : attribute5Data.phone} */}
            {checkDvtn
              ? parsedData?.telephoneNumber
              : attribute5Data?.phone || dataOrderDetail?.cusTelephone}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Mã yêu cầu xuất kho
          </Text>
        ),
      },
      {
        content:
          !isEdit && !haveSourceCode ? (
            <Tooltip
              label={
                dataOutWard?.sourceCode
                  ? dataOutWard?.sourceCode
                  : "Vui lòng chọn phiếu"
              }
            >
              <Select
                w={"160px"}
                placeholder="Mã hóa đơn bán lẻ"
                data={dataSearchSourceCodeOption}
                className={classesButton.text_input}
                size="sm"
                disabled={
                  !dataOutWard.sourceType ||
                  dataOutWard.status === "LOCK" ||
                  sourceCode ||
                  isSave
                }
                searchable
                clearable
                // searchValue={searchSourceCode ?? ""}
                onSearchChange={(e) => {
                  if (setSearchSourceCode) {
                    setSearchSourceCode(e);
                  }
                }}
                onKeyDown={handleKeyDownSourceCode}
                value={sourceCode || dataOutWard?.sourceCode}
                onChange={(value) => {
                  handleChangeValueInput(value || "", "sourceCode");
                  if (setSourceCode) {
                    setSourceCode(value);
                  }
                }}
                nothingFoundMessage={"Không tìm thấy dữ liệu !"}
              />
            </Tooltip>
          ) : (
            <Text
              w={"150px"}
              size="sm"
              style={{ whiteSpace: "normal" }}
              truncate
            >
              {dataOutWard.sourceCode}{" "}
            </Text>
          ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Tỉnh Thành
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {/* {checkDvtn
              ? (
                  dataProvince?.find(
                    (item) =>
                      String(item.id) === String(parsedData?.customerProvinceId)
                  ) ?? {}
                ).nameprovince ?? null
              : dataOrderDetail?.cusProvinceName}{" "} */}
            {/* {checkDvtn
              ? (
                  dataProvince?.find(
                    (item) =>
                      String(item.id) === String(parsedData?.customerProvinceId)
                  ) ?? {}
                ).nameprovince ?? null
              : dataOrderDetail?.cusProvinceName
              ? dataOrderDetail?.cusProvinceName
              : dataCommuneMoi[0]?.att1 ?? null}{" "} */}
            {dataCommuneMoi[0]?.att1 ?? null}
          </Text>
        ),
      },
    ],
    // [
    //   {
    //     content: (
    //       <Text
    //         fw={700}
    //         w={"100px"}
    //         size="sm"
    //         style={{ whiteSpace: "normal" }}
    //         truncate
    //       >
    //         Lý do
    //       </Text>
    //     ),
    //   },
    //   {
    //     content: !isDisabled ? (
    //       <Select
    //         searchable
    //         clearable
    //         w={160}
    //         className={classesButton.text_input}
    //         placeholder="Chọn lý do"
    //         disabled={
    //           dataOutWard.status === "LOCK" ||
    //           sourceCode ||
    //           isSave ||
    //           ["DETAIL", "EDIT"].includes(action)
    //         }
    //         data={updatedDataInventoryTransactionType}
    //         value={dataOutWard.sourceType?.toString() || ""}
    //         onChange={(value) => {
    //           handleChangeValueInput(value || "", "sourceType");
    //         }}
    //       />
    //     ) : (
    //       <Text
    //         fw={700}
    //         w={"100px"}
    //         size="sm"
    //         style={{ whiteSpace: "normal" }}
    //         truncate
    //       >
    //         {
    //           updatedDataInventoryTransactionType?.find(
    //             (t) => t.value === dataOutWard.sourceType?.toString()
    //           )?.label
    //         }
    //       </Text>
    //     ),
    //   },
    //   {
    //     content: null,
    //   },
    //   {
    //     content: null,
    //   },
    // ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Chi nhánh
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataBranch &&
              dataBranch?.find(
                (i: any) =>
                  String(i?.orgId) === String(dataOrderDetail?.fromBranchId),
              )?.orgCode}{" "}
            - {dataOrderDetail.fromBranchName}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Phường Xã
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {/* {checkDvtn
              ? dataCommune?.find(
                  String(item.value) === String(parsedData?.customerCommuneId)
                )?.text ?? null
              : dataOrderDetail?.cusCommuneName
              ? dataOrderDetail?.cusCommuneName
              : dataCommuneMoi[0]?.text ?? null} */}
            {dataCommuneMoi[0]?.text ?? null}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Địa điểm làm việc
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail.fromBranchAddress}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Địa chỉ cụ thể
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {checkDvtn
              ? parsedData?.customerAddress
              : dataOrderDetail?.cusAddress}{" "}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Kho
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail.fromInvCode
              ? `${dataOrderDetail.fromInvCode} - ${
                  dataOrderDetail.fromInvName || ""
                }`
              : dataOrderDetail.fromInvName || ""}
          </Text>
        ),
      },
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Thời gian nhận
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {formatDateTransfer(
              checkDvtn
                ? parsedData?.deliveryAppointmentTime
                : dataOrderDetail?.receiveDate || "",
            )}
          </Text>
        ),
      },
    ],

    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Họ & Tên
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.createName
              ? dataOrderDetail?.createName +
                " - " +
                dataOrderDetail?.createCode
              : ""}
          </Text>
        ),
      },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Chức danh
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {dataOrderDetail?.createRoleName || ""}
          </Text>
        ),
      },
      { content: null },
      { content: null },
    ],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Giao hàng
          </Text>
        ),
      },
      {
        content: (
          <Text w={"150px"} size="sm" style={{ whiteSpace: "normal" }} truncate>
            {" "}
            {getDeliveryText(dataOrderDetail?.delivery || "")}
          </Text>
        ),
      },
      { content: null },
      { content: null },
    ],
    // isLocked || isEdit
    //   ?
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Diễn giải chứng từ gốc
          </Text>
        ),
      },
      {
        content: (
          <Text size="sm" w={"500px"}>
            {dataOutWard?.sourceDescription}
          </Text>
        ),
        colSpan: 3,
      },
    ],
    // : [],
    [
      {
        content: (
          <Text
            fw={700}
            w={"100px"}
            size="sm"
            style={{ whiteSpace: "normal" }}
            truncate
          >
            Ghi chú
          </Text>
        ),
      },
      {
        content: (
          <TextInput
            error={
              dataOutWard?.description && dataOutWard.description.length > 300
                ? "Ghi chú không được vượt quá 300 kí tự!"
                : null
            }
            className={classesButton.text_input}
            value={dataOutWard?.description ?? ""}
            onChange={(e) =>
              handleChangeValueInput(e.target.value, "description")
            }
            disabled={isLocked}
            placeholder={isLocked ? "" : "Vui lòng nhập"}
          />
        ),
        colSpan: 3,
      },
    ],
  ];

  return <RenderTable headers={headers} rows={rows} />;
};

type SaleOrderOutwardProps = {
  dataSearchSourceCodeOption?: any[];
  dataPosition?: ComboboxItem[];
  dataOutWard: tblInventoryTransaction;
  dataOrderDetail: any;
  handleChangeValueInput: (value: string | boolean | null, key: string) => void;
  setSourceCode?: (value: any) => void;
  handleKeyDownSourceCode?: (e: any) => void;
  sourceCode?: any;
  isSave?: boolean;
  setSearchSourceCode?: (newValue: React.SetStateAction<string>) => void;
  isEdit?: boolean;
  isLocked?: boolean;
  haveSourceCode?: boolean;
  action: string;
  dataBranch: any;
  updatedDataInventoryTransactionType?: ComboboxItem[];
};

export default SaleOrderOutward;
